import CardList from './component';
export default CardList;



// WEBPACK FOOTER //
// ./src/foundation/ui/controls/card-list/index.js